import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "order" };
const _hoisted_2 = { class: "order__header" };
const _hoisted_3 = { class: "order__branch" };
const _hoisted_4 = {
    key: 0,
    class: "order__supplierBranchInformation"
};
const _hoisted_5 = { class: "order__shipping" };
const _hoisted_6 = { class: "order__items" };
const _hoisted_7 = { class: "table table--condensed" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "order__quantity" };
const _hoisted_11 = { class: "order__quantity" };
const _hoisted_12 = { class: "order__quantity" };
const _hoisted_13 = {
    key: 0,
    class: "order__quantity"
};
const _hoisted_14 = { class: "order-total" };
const _hoisted_15 = { colspan: "3" };
const _hoisted_16 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_17 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_18 = { class: "order__tax" };
const _hoisted_19 = { class: "order__tax-label" };
const _hoisted_20 = { class: "order__tax-netto" };
const _hoisted_21 = { class: "order__tax-value" };
const _hoisted_22 = { class: "order-total" };
const _hoisted_23 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_24 = { class: "order__comment" };
const _hoisted_25 = { class: "form__group" };
const _hoisted_26 = { class: "form__label-wrapper" };
const _hoisted_27 = { class: "form__control-wrapper" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    key: 0,
    class: "form__buttons"
};
const _hoisted_30 = {
    class: "button button--outline button--small",
    type: "submit"
};
import { computed, ref, watch } from "vue";
import { onBeforeRouteLeave } from 'vue-router';
import VensoOrderItem from "@/components/VensoOrderItem.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import VensoNoticeItemDraft from "@/components/VensoNoticeItemDraft.vue";
import { formatCHF } from "@/utils/currency";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoOrder',
    props: {
        order: {},
        taxRates: {}
    },
    emits: ['updateQuantity', 'addNoticeItem', 'removeNoticeItem', 'saveComment'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        // notice items with no corresponding order item
        const additionalNoticeItems = computed(() => {
            return (props.order.deliveryNotice?.items || []).filter(item => !props.order.items.find(oi => item.position === oi.position));
        });
        const comment = ref(props.order.deliveryNotice?.comment || null);
        const saved = ref(false);
        const hasComment = ref(comment.value !== null);
        const commentRequired = computed(() => {
            return additionalNoticeItems.value.length > 0 ||
                props.order.items.some(orderItem => {
                    const noticeItem = findNoticeItem(orderItem);
                    return noticeItem && orderItem.quantity !== noticeItem.quantity;
                });
        });
        function roundRappen(value) {
            return Math.sign(value) * Math.round(Math.abs(value) * 100 + Number.EPSILON) / 100;
        }
        const taxSummary = computed(() => {
            const groups = new Map();
            for (const item of props.order.allItems) {
                const key = item.taxRate ?? '0';
                const netto = Number(item.positionTotal ?? 0);
                const existing = groups.get(key);
                if (existing) {
                    existing.netto += netto;
                }
                else {
                    groups.set(key, { taxRate: Number(item.taxRate ?? 0), netto });
                }
            }
            return Array.from(groups.values())
                .sort((a, b) => a.taxRate - b.taxRate)
                .map(g => ({
                taxRate: g.taxRate,
                netto: roundRappen(g.netto),
                tax: roundRappen(g.netto * g.taxRate),
            }));
        });
        const totalBrutto = computed(() => roundRappen(Number(props.order.orderTotal) + taxSummary.value.reduce((sum, g) => sum + g.tax, 0)));
        const noticeLocked = computed(() => !!(props.order.deliveryNotice?.status === 'locked' || props.order.deliveryReceipt));
        const deliveryDayPassed = computed(() => {
            return props.order.deliveryDate < new Date().toISOString().split('T')[0];
        });
        const editable = computed(() => !noticeLocked.value && !deliveryDayPassed.value);
        const showAdditionalItemRow = ref(false);
        function findNoticeItem(orderItem) {
            if (!props.order.deliveryNotice) {
                return undefined;
            }
            return props.order.deliveryNotice.items.find(item => item.position === orderItem.position);
        }
        function findReceiptItem(position) {
            if (!props.order.deliveryReceipt) {
                return undefined;
            }
            return props.order.deliveryReceipt.items.find(item => item.position === position);
        }
        function onQuantityUpdate(item, quantity) {
            const update = {
                orderId: props.order.id,
                position: item.position,
                quantity: quantity,
            };
            emit('updateQuantity', update);
        }
        function addNoticeItem(item) {
            item.orderId = props.order.id;
            emit('addNoticeItem', item);
            showAdditionalItemRow.value = false;
        }
        function removeNoticeItem(item) {
            const itemRef = {
                orderId: props.order.id,
                position: item.position,
            };
            emit('removeNoticeItem', itemRef);
        }
        function saveComment() {
            if (!editable.value) {
                return;
            }
            emit('saveComment', comment.value);
            saved.value = true;
            hasComment.value = comment.value !== null;
        }
        watch(comment, () => {
            saved.value = false;
            hasComment.value = comment.value !== null && saved.value;
        });
        const commentInput = ref(null);
        onBeforeRouteLeave((to, from, next) => {
            if (commentRequired.value && !hasComment.value) {
                commentInput.value?.focus();
                commentInput.value?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                alerts.warning(trans('venso_order.comment_required'));
                return next(false);
            }
            next();
        });
        watch(commentRequired, (required) => {
            if (required && !hasComment.value) {
                commentInput.value?.focus();
                alerts.warning(trans('venso_order.comment_required'));
            }
        });
        const handler = (e) => {
            if (commentRequired.value && !hasComment.value) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handler);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.order.branch.name) + " / " + _toDisplayString(__props.order.orderNumber), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (__props.order.supplierBranchInformation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('venso_order.supplierBranchInformation.customerNumber')) + " " + _toDisplayString(__props.order.supplierBranchInformation.customerNumber), 1))
                        : _createCommentVNode("", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('venso_order.shipping_to')) + " " + _toDisplayString(__props.order.branch.address) + ",\n                " + _toDisplayString(__props.order.branch.zip) + " " + _toDisplayString(__props.order.branch.city), 1)
                ]),
                _cache[27] || (_cache[27] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_order.items')), 1),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1)),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("th", {
                                    class: "order__quantity",
                                    innerHTML: _ctx.$t('venso_order_item.base_price')
                                }, null, 8, _hoisted_8),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                _createElementVNode("th", {
                                    class: "order__quantity",
                                    innerHTML: _ctx.$t('venso_order_item.price')
                                }, null, 8, _hoisted_9),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('venso_order_item.total')), 1),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('venso_order_item.quantity_ordered')), 1),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('venso_order_item.quantity_notified')), 1),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                (__props.order.deliveryReceipt)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(_ctx.$t('venso_order_item.quantity_received')), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _cache[24] || (_cache[24] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.items, (item, index) => {
                                return (_openBlock(), _createBlock(VensoOrderItem, {
                                    item: item,
                                    currency: __props.order.currency,
                                    "notice-item": findNoticeItem(item),
                                    "receipt-item": findReceiptItem(item.position),
                                    onUpdateQuantity: (qty) => onQuantityUpdate(item, qty),
                                    locked: !editable.value,
                                    key: index
                                }, null, 8, ["item", "currency", "notice-item", "receipt-item", "onUpdateQuantity", "locked"]));
                            }), 128)),
                            _cache[19] || (_cache[19] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalNoticeItems.value, (noticeItem, index) => {
                                return (_openBlock(), _createBlock(VensoOrderItem, {
                                    "notice-item": noticeItem,
                                    "receipt-item": findReceiptItem(noticeItem.position),
                                    currency: __props.order.currency,
                                    onRemoveItem: () => removeNoticeItem(noticeItem),
                                    onUpdateQuantity: (qty) => onQuantityUpdate(noticeItem, qty),
                                    locked: !editable.value,
                                    key: index
                                }, null, 8, ["notice-item", "receipt-item", "currency", "onRemoveItem", "onUpdateQuantity", "locked"]));
                            }), 128)),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            (showAdditionalItemRow.value)
                                ? (_openBlock(), _createBlock(VensoNoticeItemDraft, {
                                    key: 0,
                                    onSave: addNoticeItem,
                                    "tax-rates": __props.taxRates,
                                    currency: __props.order.currency
                                }, null, 8, ["tax-rates", "currency"]))
                                : _createCommentVNode("", true),
                            _cache[21] || (_cache[21] = _createTextVNode()),
                            _createElementVNode("tr", _hoisted_14, [
                                _createElementVNode("td", _hoisted_15, [
                                    (editable.value && !showAdditionalItemRow.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "button button--outline button--small",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (showAdditionalItemRow.value = true))
                                        }, [
                                            _createVNode(Icon, { name: "add" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('venso_order.add_notice_item')), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('venso_order.total_net')) + " " + _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.order.orderTotal)), 1)
                            ]),
                            _cache[22] || (_cache[22] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxSummary.value, (tax) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: tax.taxRate,
                                    class: "order-total order-total--tax"
                                }, [
                                    _cache[15] || (_cache[15] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('venso_order_item.tax')) + " " + _toDisplayString(_unref(formatCHF)(tax.taxRate * 100)) + "%\n                                ", 1),
                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_20, "\n                                    (" + _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(tax.netto)) + ")\n                                ", 1)
                                            ]),
                                            _cache[14] || (_cache[14] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_21, _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(tax.tax)), 1)
                                        ])
                                    ])
                                ]));
                            }), 128)),
                            _cache[23] || (_cache[23] = _createTextVNode()),
                            _createElementVNode("tr", _hoisted_22, [
                                _cache[17] || (_cache[17] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t('venso_order.total_brutto')) + " " + _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(totalBrutto.value)), 1)
                            ])
                        ])
                    ])
                ]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("form", {
                        class: "form form--simple",
                        onSubmit: _withModifiers(saveComment, ["prevent"])
                    }, [
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("label", {
                                    class: _normalizeClass(["form__label", commentRequired.value ? 'form__label--required' : '']),
                                    for: "comment"
                                }, _toDisplayString(_ctx.$t('venso_delivery.notice_comment')), 3)
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("textarea", {
                                    ref_key: "commentInput",
                                    ref: commentInput,
                                    class: "form__control",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((comment).value = $event)),
                                    rows: "1",
                                    disabled: !editable.value,
                                    id: "comment",
                                    name: "comment"
                                }, null, 8, _hoisted_28), [
                                    [_vModelText, comment.value]
                                ])
                            ])
                        ]),
                        _cache[26] || (_cache[26] = _createTextVNode()),
                        (editable.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("button", _hoisted_30, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('save')) + " ", 1),
                                    _createVNode(Icon, {
                                        name: saved.value ? 'check' : 'save'
                                    }, null, 8, ["name"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ], 32)
                ])
            ]));
        };
    }
});
